(function ($) {
    $.validator.unobtrusive.adapters.addBool("mustbetrue", "required");
}(jQuery));
